<template>
  <div class="PageGuardReservationMain">
    <div class="warpper">
      <div class="page-form">
        <el-form ref="form" label-position="top">
          <el-form-item>
            <el-date-picker
              v-model="queryForm.reserveDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('pages.wording.placeholderDate')"
              @change="queryReserveData(true)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              multiple
              v-model="queryForm.factoryList"
              :placeholder="$t('pages.wording.placeholderFactory')"
              @change="queryReserveData(true)"
            >
              <el-option v-for="item in selection.factoryBase" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="queryForm.carPlat"
              @change="queryReserveData(true)"
              :placeholder="$t('pages.wording.placeholderSearchCarPlat')"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Tabs :tabsData.sync="tabsData" :active="activeTab" @tabClick="changeTab" class="guard-main">
      <div slot="entering">
        <div class="grid-card" v-if="enteringList.length">
          <CardOrder
            v-for="data in enteringList"
            :isActive="doorIsOpen(data.carRank)"
            :key="data.reserveID"
            @cardClick="goReserveDetailPage(data, 'entering')"
          >
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("reserve.status.entering") }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveTime") }}</div>
                <div class="value value-highlight">{{ formateDatetimeStr("Time", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.gate") }}</div>
                <div class="value">
                  {{
                    data.gateNameCode
                      ? `${$store.getters.getSysCodeText(
                          "factoryGate",
                          data.gateNameCode
                        )} (${$store.getters.getSysCodeText("factoryName", data.factoryNameCode)})`
                      : ""
                  }}
                </div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.driverID") }}</div>
                <div class="value">{{ data.tempCar ? data.tmpDriverID : data.driverID }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
        <NoData v-else></NoData>
      </div>
      <div slot="in1">
        <div class="grid-card" v-if="in1List.length">
          <CardOrder v-for="data in in1List" :key="data.reserveID" @cardClick="goReserveDetailPage(data, 'in1')">
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("reserve.status.in1") }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveTime") }}</div>
                <div class="value value-highlight">{{ formateDatetimeStr("Time", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.gate") }}</div>
                <div class="value">
                  {{
                    data.gateNameCode
                      ? `${$store.getters.getSysCodeText(
                          "factoryGate",
                          data.gateNameCode
                        )} (${$store.getters.getSysCodeText("factoryName", data.factoryNameCode)})`
                      : ""
                  }}
                </div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.driverID") }}</div>
                <div class="value">{{ data.tempCar ? data.tmpDriverID : data.driverID }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
        <NoData v-else></NoData>
      </div>
      <div slot="in2">
        <div class="grid-card" v-if="in2List.length">
          <CardOrder v-for="data in in2List" :key="data.reserveID" @cardClick="goReserveDetailPage(data, 'in2')">
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("reserve.status.in2") }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveTime") }}</div>
                <div class="value value-highlight">{{ formateDatetimeStr("Time", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.gate") }}</div>
                <div class="value">
                  {{
                    data.gateNameCode
                      ? `${$store.getters.getSysCodeText(
                          "factoryGate",
                          data.gateNameCode
                        )} (${$store.getters.getSysCodeText("factoryName", data.factoryNameCode)})`
                      : ""
                  }}
                </div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.driverID") }}</div>
                <div class="value">{{ data.tempCar ? data.tmpDriverID : data.driverID }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
        <NoData v-else></NoData>
      </div>
      <div slot="all">
        <div class="grid-card" v-if="allList.length">
          <CardOrder v-for="data in allList" :key="data.reserveID" @cardClick="goReserveDetailPage(data, 'all')">
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("reserve.status.finished") }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveTime") }}</div>
                <div class="value value-highlight">{{ formateDatetimeStr("Time", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.gate") }}</div>
                <div class="value">
                  {{
                    data.gateNameCode
                      ? `${$store.getters.getSysCodeText(
                          "factoryGate",
                          data.gateNameCode
                        )} (${$store.getters.getSysCodeText("factoryName", data.factoryNameCode)})`
                      : ""
                  }}
                </div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.driverID") }}</div>
                <div class="value">{{ data.tempCar ? data.tmpDriverID : data.driverID }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
        <NoData v-else></NoData>
      </div>
    </Tabs>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import Tabs from "@/components/common/Tabs.vue"
import CardOrder from "@/components/common/CardOrder.vue"
import NoData from "@/components/Guard/NoData.vue"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { role } from "@/config/role.js"

export default {
  name: "PageGuardReservationMain",
  components: {
    Tabs,
    CardOrder,
    NoData,
  },
  data() {
    return {
      queryForm: {
        reserveDate: null,
        factoryList: null,
        carplat: null,
      },
      selection: {
        factoryBase: null,
      },
      activeTab: "entering",
      enteringList: [],
      in1List: [],
      in2List: [],
      allList: [],
      reflashTimeout: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions(["toggleMainSidebar"]),
    ...mapGetters(["getUserProfile", "getToggleMainSidebar"]),
    init() {
      if (this.getToggleMainSidebar()) {
        this.toggleMainSidebar()
      }
      this.initTab()
      let userRegion = utils.getFirstOrDefault(this.getUserProfile().region)
      let userArea = this.getUserProfile().area
      let userFactory = this.getUserProfile().factory

      //keep query value
      let prevPageParams = window.sessionStorage.getItem("guardQueryParams")
      window.sessionStorage.removeItem("guardQueryParams")
      if (prevPageParams !== null) {
        let prevPageObject = JSON.parse(prevPageParams)
        this.queryForm.reserveDate = prevPageObject.reserveDate
        this.queryForm.factoryList = prevPageObject.factoryList
        //this.queryForm.carPlat = prevPageObject.carPlat
      } else {
        this.queryForm.reserveDate = utils.parseDateToDateFormat(new Date())
      }
      this.getFactory(userRegion, userArea, userFactory)
      this.queryReserveData(true)
    },
    initTab() {
      if (this.getUserProfile().userLoginRole.includes(role.GUARD_S1)) {
        this.activeTab = "entering"
      } else if (this.getUserProfile().userLoginRole.includes(role.GUARD_S2)) {
        this.activeTab = "in1"
      } else if (this.getUserProfile().userLoginRole.includes(role.GUARD_S3)) {
        this.activeTab = "in2"
      } else {
        this.activeTab = "entering"
      }
    },
    queryReserveData(needReflashTimeout) {
      let vueInstance = this
      let params = {
        reserveArriveDate: vueInstance.queryForm.reserveDate,
        reserveArea: vueInstance.getUserProfile().area,
        reserveFactory: vueInstance.queryForm.factoryList,
        carPlat: vueInstance.queryForm.carPlat,
      }
      if (needReflashTimeout) {
        clearTimeout(this.reflashTimeout)
      }
      api
        .apiGetReserveCountForGuard(params)
        .then((response) => {
          if (response.data) {
            vueInstance.tabsData[0].counts = response.data.enteringCount
            vueInstance.tabsData[1].counts = response.data.in1Count
            vueInstance.tabsData[2].counts = response.data.in2Count
            vueInstance.tabsData[3].counts = response.data.allCount
            vueInstance.getReserveList()
            if (needReflashTimeout) {
              this.reflashTimeout = setTimeout(() => this.queryReserveData(false), 10000)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReserveList() {
      let vueInstance = this
      let params = {
        reserveArriveDate: vueInstance.queryForm.reserveDate,
        reserveArea: vueInstance.getUserProfile().area,
        reserveFactory: vueInstance.queryForm.factoryList,
        carPlat: vueInstance.queryForm.carPlat,
        type: vueInstance.activeTab,
      }
      api
        .apiGetReserveListForGuard(params)
        .then((response) => {
          if (response.data) {
            vueInstance[`${vueInstance.activeTab}List`] = response.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFactory(region, area, factory) {
      let params = {
        region: region,
        area: area,
        factory: factory,
      }
      api
        .apiGetMultiAreasFactory(params)
        .then((response) => {
          this.selection.factoryBase = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeTab(val) {
      this.activeTab = val
      this.queryReserveData(false)
    },
    goReserveDetailPage(data, station) {
      let tempQueryParams = this.queryForm
      window.sessionStorage.setItem("guardTempQueryParams", JSON.stringify(tempQueryParams))
      this.$router.push({
        name: "PageGuardReservation_" + station,
        params: { reserveID: data.reserveID },
      })
    },
    doorIsOpen(flag) {
      return flag === "1"
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  computed: {
    tabsData() {
      return [
        {
          name: "entering",
          label: this.$t("reserve.status.entering"),
          counts: 0,
        },
        {
          name: "in1",
          label: this.$t("reserve.status.in1"),
          counts: 0,
        },
        {
          name: "in2",
          label: this.$t("reserve.status.in2"),
          counts: 0,
        },
        {
          name: "all",
          label: this.$t("reserve.status.finished"),
          counts: 0,
        },
      ]
    },
  },
  beforeDestroy() {
    clearTimeout(this.reflashTimeout)
  },
}
</script>

<style scoped>
.PageGuardReservationMain {
  margin: 0 -20px;
}

.el-form {
  margin-bottom: 8px;
}

.el-form .el-form-item {
  margin-bottom: 8px;
}

.el-form .el-form-item .el-input,
.el-form .el-form-item .el-button {
  width: 100%;
}

@media (min-width: 768px) {
  .Tabs {
    margin: 0 16px;
  }
}

.checkAll-group .el-checkbox-group {
  padding-left: 24px;
}

.checkAll-group .el-checkbox-group .el-checkbox {
  display: block;
}

.input-append {
  display: flex;
}

.input-append .el-input {
  margin-right: 8px;
}
</style>
